import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { IUIRequest } from "src/app/npr-request.model";

@Component({
  standalone: false,
  templateUrl: "./on-demand-request-warning-modal.component.html",
  styleUrls: ["../../../styles.scss"],
})
export class OnDemandRequestWarningModalComponent {
  @Input() request: IUIRequest;

  public isConfirmed: boolean = false;
  constructor(public activeModal: NgbActiveModal) { }

  onCheckboxChange(checked: boolean): void {
    this.isConfirmed = checked;
  }
}
